import { render, staticRenderFns } from "./ShowHerbariumTags.vue?vue&type=template&id=a8dff78c&scoped=true&"
import script from "./ShowHerbariumTags.vue?vue&type=script&lang=js&"
export * from "./ShowHerbariumTags.vue?vue&type=script&lang=js&"
import style0 from "./ShowHerbariumTags.vue?vue&type=style&index=0&id=a8dff78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dff78c",
  null
  
)

export default component.exports